import { tap } from 'rxjs';

import { Injectable } from '@angular/core';

import { AuthStore } from '@/app/core/store/auth';
import { HttpService } from '@/app/core/services/http';
import { SubscriptionsStore } from '@/app/core/store/subscriptions';

import { Profile } from './profile.types';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private http: HttpService,
    private authStore: AuthStore,
    private subscriptionsStore: SubscriptionsStore,
  ) {}

  getProfileInfo() {
    return this.http.get<Profile>('profile').pipe(
      tap((user) => {
        this.authStore.setAuthUser(user);

        const subscription = user?.client?.subscription;

        if (subscription) {
          this.subscriptionsStore.setSubscription(subscription);
        }
      }),
    );
  }
}
